import Vue from 'vue'
import http from '@/fetch/http'
import * as types  from '@/vuex/types'
import util from '@/utils'

const state = {
  reportListPageNo: 1,// 试题库列表页面当前页数
  reportList:[]
}

const actions = {
  // 改变当前页数
  setReportListPageNo({commit}, params){
    commit("SET_REPORT_LIST_PAGE_NO", params);
  },
  setReportList({commit}, params){
    commit("SET_REPORT_LIST", params);
  }
}

const getters = {}

const mutations = {
  ['SET_REPORT_LIST_PAGE_NO'](state, params) {
    Vue.set(state, 'reportListPageNo', params);
  },
  ['SET_REPORT_LIST'](state, params) {
    Vue.set(state, 'reportList', params);
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/reportlibrary.js